/**
 * Picker Page - Batch list page wrapper
 *
 * Routes to this page:
 * - /production/picker - View created batches ready for picking
 *
 * This is the starting point for the Picker workflow.
 * Shows batch list, allows printing labels and picklists.
 */

import { PickerPage } from '@/features/production-orders';

export default function Picker() {
  return <PickerPage />;
}
